import React from 'react';
import {
  TrashContainer,
  Trash,
  Tap,
  Tap2,
  Tip,
  Top,
  Bottom,
  Line
} from './StyledComponents';

const TrashIcon = ({ onClick }) => (
  <TrashContainer onClick={onClick}>
    <Trash>
      <Tap className="tap">
        <Tip className="trash-part" />
        <Top className="trash-part" />
      </Tap>
      <Tap2>
        <Bottom className="trash-part">
          <Line />
          <Line />
        </Bottom>
      </Tap2>
    </Trash>
  </TrashContainer>
);

export default TrashIcon; 